import React, {Component} from 'react';
import ClientUsers from '../../Employees/ClientUsers'
import {isEmpty} from 'lodash'
import "./tm.css"
import qs from 'qs';

class TeamMembers extends Component {
  componentDidMount(){
    if (isEmpty(this.props.clientRoles))
      this.props.getClientRoles()
  }
  showTableTitle () {
    if (/^(\/clients\/edit\/Business-Units\/detail\/Team Members)/g.test(this.props.location.pathname)) {
      if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
        return (
          <h3 className="mb-20" style={{fontSize: '16px', fontWeight: 'bolder'}}>
            {qs.parse(this.props.location.search.split('?')[1]).name.toUpperCase()} BUSINESS UNIT TEAM MEMBERS
          </h3>
        )
      }
    }
    if (/^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname)) {
      if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
        return (
          <h3 className="mb-20" style={{fontSize: '16px', fontWeight: 'bolder'}}>
            {/^(administrator|team member)/gi.test(this.props.roleName) ? 'BUSINESS UNIT' : 'CLIENT'} TEAM MEMBERS
          </h3>
        )
      }
      if (/^(administrator|team member)/gi.test(this.props.roleName)) {
        return (
          <h3 className="mb-20" style={{fontSize: '16px', fontWeight: 'bolder'}}>
            {qs.parse(this.props.location.search.split('?')[1]).name.toUpperCase()} BUSINESS UNIT TEAM MEMBERS
          </h3>
        )
      }
    }
  }
	render(){
		return(
			<div className="team-members-container">
				<div className="team-members-main">
          {this.showTableTitle()}
          {/*{*/}
            {/*(/^(\/clients\/edit\/Business-Units\/detail\/Team Member|\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) &&*/}
            {/*/^(administrator|team member)/gi.test(this.props.roleName))*/}
              {/*? (*/}
              {/*<h3 className="mb-20" style={{fontSize: '16px', fontWeight: 'bolder'}}>*/}
                {/*{qs.parse(this.props.location.search.split('?')[1]).name.toUpperCase()} BUSINESS UNIT TEAM MEMBERS*/}
              {/*</h3>*/}
            {/*) : (*/}
              {/*<h3 className="mb-20" style={{fontSize: '16px', fontWeight: 'bolder'}}>*/}
                {/*{/^(administrator|team member)/gi.test(this.props.roleName) ? 'BUSINESS UNIT' : 'CLIENT'} TEAM MEMBERS*/}
              {/*</h3>*/}
            {/*)*/}
          {/*}*/}
          <ClientUsers
            tableList={this.props.tableList}
            getTableList={
              (/^(\/clients\/edit\/Business-Units\/detail\/Team Members)/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) ?
              this.props.getBusinessUnitTeamMembers :
                ((/^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) && /^(administrator|team member)/gi.test(this.props.roleName)) ?
              this.props.getBusinessUnitTeamMembers :
              this.props.getClientUsers)
            }
            ifSendInviteSuccess={this.props.ifSendInviteSuccess}
            {...this.props}
            // for system administrator | account manager
            suspendOrReactivate={
              /^(\/clients\/edit\/Business-Units\/detail\/Team Members)/g.test(this.props.location.pathname)
            }
            selected_client={this.props.match.params.id} 
            clientId={this.props.match.params.id}
            roles={this.props.clientRoles}
            roleName={this.props.roleName}
            rollbackStatus={this.props.rollbackStatus}
          />
        </div>
      </div>
    )
  }
}

export default TeamMembers


// WEBPACK FOOTER //
// ./src/components/Clients/EditClientProfile/TeamMembers.jsx